export default {
  type: 'doc',
  content: [
    {
      type: 'table',
      attrs: {
        layout: 'default',
        localId: '0f869de7-78d8-42cf-bc3b-9f7bf1469e9b'
      },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [146.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Competitor',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [494.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [146.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Date created',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [494.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [146.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Analysis by',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [494.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '@ mention owner',
                      type: 'text',
                      marks: [
                        { type: 'textColor', attrs: { color: '#97a0af' } }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [146.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Tier (1-3)',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [494.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Tier 1 - major competitor / Tier 2 - moderate competitor / Tier 3 - minor competitor',
                      type: 'text',
                      marks: [
                        { type: 'textColor', attrs: { color: '#97a0af' } }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          type: 'emoji',
          attrs: {
            id: '1f3c5',
            text: '\\\\uD83C\\\\uDFC5',
            shortName: ':medal:'
          }
        },
        {
          text: ' ',
          type: 'text'
        },
        { text: 'Competitor profile', type: 'text' }
      ]
    },
    {
      type: 'table',
      attrs: {
        layout: 'default',
        localId: '0ebddfd2-3456-4650-9bf5-d4b538da2244'
      },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [180.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Company mission',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#ffffff',
                rowspan: 1,
                colwidth: [578.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'e.g., Unleash the potential of every team',
                      type: 'text',
                      marks: [
                        { type: 'textColor', attrs: { color: '#97a0af' } }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [180.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Key objectives',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [578.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'e.g., maintain majority market share',
                      type: 'text',
                      marks: [
                        { type: 'textColor', attrs: { color: '#97a0af' } }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [180.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Capabilities',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [578.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'e.g., Key partnerships in the enterprise space',
                      type: 'text',
                      marks: [
                        { type: 'textColor', attrs: { color: '#97a0af' } }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [180.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Company size',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [578.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [180.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Revenue',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [578.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        }
      ]
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          type: 'emoji',
          attrs: {
            id: '1f3c6',
            text: '\\\\uD83C\\\\uDFC6',
            shortName: ':trophy:'
          }
        },
        {
          text: ' ',
          type: 'text'
        },
        { text: 'Our competitive advantage', type: 'text' }
      ]
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Key differentiators:',
                  type: 'text',
                  marks: [{ type: 'strong' }]
                },
                {
                  text: 'e.g., Powerful features for highly technical users',
                  type: 'text',
                  marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          type: 'emoji',
          attrs: {
            id: '1f4c8',
            text: '\\\\uD83D\\\\uDCC8',
            shortName: ':chart_with_upwards_trend:'
          }
        },
        { text: ' ', type: 'text' },
        { text: 'Target market & market share', type: 'text' }
      ]
    },
    {
      type: 'table',
      attrs: {
        layout: 'default',
        localId: 'b743c6b0-e01c-4e3f-be8c-f0e883fc0ef6'
      },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [148.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#f4f5f7',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Competitor',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#f4f5f7',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Your company',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#f4f5f7',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Commentary',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#f4f5f7',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Target market',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#f4f5f7',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Verticals',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#f4f5f7',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Market share',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        }
      ]
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          type: 'emoji',
          attrs: {
            id: '1f4ff',
            text: '\\\\uD83D\\\\uDCFF',
            shortName: ':prayer_beads:'
          }
        },
        {
          text: ' ',
          type: 'text'
        },
        { text: 'Product offering', type: 'text' }
      ]
    },
    {
      type: 'table',
      attrs: {
        layout: 'default',
        localId: 'ec2ec37e-665d-409d-9afc-ead253ba3786'
      },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Competitor',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Your company',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Commentary',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Product overview',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Positioning/ Category',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Pricing',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 4,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0, 204.0, 204.0, 204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Core feature comparison',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Feature 1',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'emoji',
                      attrs: {
                        id: 'atlassian-check_mark',
                        text: ':check_mark:',
                        shortName: ':check_mark:'
                      }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'emoji',
                      attrs: {
                        id: 'atlassian-check_mark',
                        text: ':check_mark:',
                        shortName: ':check_mark:'
                      }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#eae6ff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Feature 2',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'emoji',
                      attrs: {
                        id: 'atlassian-check_mark',
                        text: ':check_mark:',
                        shortName: ':check_mark:'
                      }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'emoji',
                      attrs: {
                        id: 'atlassian-cross_mark',
                        text: ':cross_mark:',
                        shortName: ':cross_mark:'
                      }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        }
      ]
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          type: 'emoji',
          attrs: {
            id: '1f4e3',
            text: '\\\\uD83D\\\\uDCE3',
            shortName: ':mega:'
          }
        },
        {
          text: ' ',
          type: 'text'
        },
        { text: 'Marketing Strategies', type: 'text' }
      ]
    },
    {
      type: 'paragraph',
      content: [
        {
          text: "Fill in the table below with information about the tools your competitor is using and how they're using them. Include specific details, such as the number of related properties, quality, and target audience.",
          type: 'text',
          marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }]
        }
      ]
    },
    {
      type: 'paragraph',
      content: [
        {
          text: 'To add visuals, type /image or drag an image onto the page.',
          type: 'text',
          marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }]
        }
      ]
    },
    {
      type: 'table',
      attrs: {
        layout: 'default',
        localId: '7a364aea-ec90-4eee-8b7c-3236665f18e4'
      },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Competitor',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Your company',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [204.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Notes and Links',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Overall strategy',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Website',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Blog/Content',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Social presence',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    { text: 'SEO', type: 'text', marks: [{ type: 'strong' }] }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Online advertising',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Offline advertising',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Videos and webinars',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Major events',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Customer resources',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Customer review listings',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Press releases and mentions',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Customer engagement',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Social proof (customer logos)',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [148.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Partnerships and investments',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        }
      ]
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          type: 'emoji',
          attrs: {
            id: '1f50e',
            text: '\\\\uD83D\\\\uDD0E',
            shortName: ':mag_right:'
          }
        },
        {
          text: ' ',
          type: 'text'
        },
        { text: 'SWOT analysis', type: 'text' }
      ]
    },
    {
      type: 'paragraph',
      content: [
        {
          text: "List your product or company's strengths, weaknesses, opportunities, and threats in the table below",
          type: 'text',
          marks: [{ type: 'textColor', attrs: { color: '#97a0af' } }]
        }
      ]
    },
    {
      type: 'table',
      attrs: {
        layout: 'default',
        localId: 'a1fa409c-8108-417a-91f1-d22455ec1b08'
      },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#e3fcef',
                rowspan: 1,
                colwidth: [320.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Strengths',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#fffae6',
                rowspan: 1,
                colwidth: [320.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Opportunities',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [320.0] },
              content: [
                {
                  type: 'bulletList',
                  content: [
                    { type: 'listItem', content: [{ type: 'paragraph' }] }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [320.0] },
              content: [
                {
                  type: 'bulletList',
                  content: [
                    { type: 'listItem', content: [{ type: 'paragraph' }] }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#deebff',
                rowspan: 1,
                colwidth: [320.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Weaknesses',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: {
                colspan: 1,
                background: '#ffebe6',
                rowspan: 1,
                colwidth: [320.0]
              },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Threats',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [320.0] },
              content: [
                {
                  type: 'bulletList',
                  content: [
                    { type: 'listItem', content: [{ type: 'paragraph' }] }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [320.0] },
              content: [
                {
                  type: 'bulletList',
                  content: [
                    { type: 'listItem', content: [{ type: 'paragraph' }] }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  version: 1
};
